// Helper per il codice fiscale italiano.
//
// Il CF a 16 caratteri ha posizioni alternate lettera/cifra:
//   pos 1-6   → 6 lettere (cognome 3 + nome 3, consonanti poi vocali)
//   pos 7-8   → 2 cifre (anno nascita)
//   pos 9     → 1 lettera (mese: A B C D E H L M P R S T)
//   pos 10-11 → 2 cifre (giorno; per donne +40)
//   pos 12    → 1 lettera (codice catastale, lettera iniziale)
//   pos 13-15 → 3 cifre (codice catastale, parte numerica)
//   pos 16    → 1 lettera (carattere di controllo)
//
// Gli scambi O↔0 e I↔1 si correggono in automatico, ma solo nelle posizioni
// dove il tipo di carattere è certo. S↔5, B↔8, Z↔2 no: darebbero falsi positivi.
const CF_DIGIT_POSITIONS = [6, 7, 9, 10, 12, 13, 14]; // index 0-based
const CF_LETTER_POSITIONS = [0, 1, 2, 3, 4, 5, 8, 11, 15];

/**
 * Normalizza un codice fiscale: toglie gli spazi, mette in maiuscolo e corregge
 * O↔0 e I↔1. Sotto i 16 caratteri non corregge (l'utente sta ancora scrivendo).
 */
export const normalizeFiscalCode = (raw: string | null | undefined): string => {
    if (!raw) return '';
    const stripped = raw.replace(/\s/g, '').toUpperCase();
    if (stripped.length !== 16) return stripped;
    const chars = stripped.split('');
    CF_DIGIT_POSITIONS.forEach(i => {
        if (chars[i] === 'O') chars[i] = '0';
        else if (chars[i] === 'I') chars[i] = '1';
    });
    CF_LETTER_POSITIONS.forEach(i => {
        if (chars[i] === '0') chars[i] = 'O';
        else if (chars[i] === '1') chars[i] = 'I';
    });
    return chars.join('');
};

/** Regex formato CF: 6 lettere + 2 cifre + 1 lettera + 2 cifre + 1 lettera + 3 cifre + 1 lettera. */
export const CF_REGEX = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;

/** Verifica solo il formato, non il carattere di controllo. */
export const isValidFiscalCodeFormat = (cf: string): boolean => CF_REGEX.test(cf);
